export { default } from "./GlobalStyles.js";